module.exports = __webpack_public_path__ + "img/PXL_20230523_142009075.1feb3564.jpg";